import { Card, CardContent } from '@mui/material';
import { Handle, Position } from "reactflow";
import {
  ElectricBolt,
  AccountTree,
  Message,
  Splitscreen,
  FormatListBulleted,
  PlayArrow,
  Stop,
  WhatsApp,
  AutoAwesome,
  Polyline,
  ArrowForward,
  Description,
  Movie,
  Image,
  Storage,
  PictureAsPdf,
  CloudUpload,
  Inbox,
  SupportAgent,
} from '@mui/icons-material';
import { useReactFlow } from 'reactflow';


export const EventNode = ({ data, selected }) => (
    <Card sx={{
        minWidth: 150,
        border: selected ? '2px solid black' : '1px solid black',
        borderRadius: 2,
        background: selected ? 'darkcyan' :'lightcyan'
    }}>
        <Handle
            type="target"
            position={Position.Left}
            onConnect={(params) => console.log('handle onConnect', params)}
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                left: '-6px'
            }}
        />
        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <ElectricBolt fontSize="small" />
            <div>
                <div style={{ fontWeight: 500 }}>{data.label}</div>
                <div style={{ fontSize: '0.875rem', color: 'text.secondary' }}>{data.triggerType}</div>
            </div>
        </CardContent>
        <Handle
            type="source"
            position={Position.Right}
            id="a"
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                right: '-6px'
            }}
        />
    </Card>
);

export const ConditionNode = ({ data, selected }) => (
    <Card sx={{
        minWidth: 150,
        border: selected ? '1px solid blue' : '1px solid black',
        borderRadius: 2,
        background: 'lightyellow'
    }}>
        <Handle
            type="target"
            position={Position.Left}
            onConnect={(params) => console.log('handle onConnect', params)}
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                left: '-6px'
            }}
        />
        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <AccountTree fontSize="small" />
            <div>
                <div style={{ fontWeight: 500 }}>{data.label}</div>
                <div style={{ fontSize: '0.875rem', color: 'text.secondary' }}>{data.description}</div>
            </div>
        </CardContent>
        <Handle
            type="source"
            position={Position.Right}
            id="true"
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                right: '-6px'
            }}
        />
        <Handle
            type="source"
            position={Position.Right}
            id="false"
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                top: '52px',
                right: '-6px'
            }}
        />
    </Card>
);

export const MessageNode = ({ data, selected }) => {
    // Función para truncar el texto y mostrar "..." si es muy largo
    const truncate = (text, maxLength = 36) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    return (
        <Card sx={{
            minWidth: 150,
            border: selected ? '2px solid black' : '1px solid black',
            borderRadius: 2,
            background: selected ? 'lightgray': 'white'
        }}>
            <Handle
                type="target"
                position={Position.Left}
                onConnect={(params) => console.log('handle onConnect', params)}
                isConnectable={true}
                style={{
                    width: '12px',
                    height: '12px',
                    background: 'white',
                    border: '1px solid black',
                    borderRadius: '50%',
                    left: '-6px'
                }}
            />
            <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Message fontSize="small" />
                <div>
                    <div style={{ fontWeight: 500 }}>{truncate(data.label, 40)}</div>
                    <div style={{ fontSize: '0.875rem', color: 'text.secondary' }}>
                        {truncate(data.description, 40)}
                    </div>
                </div>
            </CardContent>
            <Handle
                type="source"
                position={Position.Right}
                id="a"
                isConnectable={true}
                style={{
                    width: '12px',
                    height: '12px',
                    background: 'white',
                    border: '1px solid black',
                    borderRadius: '50%',
                    right: '-6px'
                }}
            />
        </Card>
    );
};

export const ButtonNode = ({ data, selected }) => {
  const getHeaderSummary = () => {
    const { headerType, headerText, mediaId } = data || {};

    if (!headerType) return 'Mensaje con opciones';

    if (headerType === 'text') {
      if (!headerText) return 'Header de texto';
      const text = headerText.length > 30 ? headerText.slice(0, 30) + '…' : headerText;
      return `Header: "${text}"`;
    }

    if (headerType === 'image') return mediaId ? `Header imagen · ${mediaId}` : 'Header imagen (mediaId)';
    if (headerType === 'video') return mediaId ? `Header video · ${mediaId}` : 'Header video (mediaId)';
    if (headerType === 'document') return mediaId ? `Header doc · ${mediaId}` : 'Header documento (mediaId)';

    return 'Mensaje con opciones';
  };

  return (
    <Card
      sx={{
        minWidth: 150,
        border: selected ? '2px solid black' : '1px solid black',
        borderRadius: 2,
        background: selected ? 'lightgray' : 'white',
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        onConnect={(params) => console.log('handle onConnect', params)}
        isConnectable={true}
        style={{
          width: '12px',
          height: '12px',
          background: 'white',
          border: '1px solid black',
          borderRadius: '50%',
          left: '-6px',
        }}
      />
      <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Splitscreen fontSize="small" />
        <div>
          <div style={{ fontWeight: 500 }}>{data.label}</div>
          <div style={{ fontSize: '0.875rem', color: 'text.secondary' }}>{getHeaderSummary()}</div>
        </div>
      </CardContent>
      <Handle
        type="source"
        position={Position.Right}
        id="button-1"
        isConnectable={true}
        style={{
          width: '12px',
          height: '12px',
          background: 'white',
          border: '1px solid black',
          borderRadius: '50%',
          right: '-6px',
        }}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="button-2"
        isConnectable={true}
        style={{
          width: '12px',
          height: '12px',
          background: 'white',
          border: '1px solid black',
          borderRadius: '50%',
          top: '52px',
          right: '-6px',
        }}
      />
    </Card>
  );
};

export const ListNode = ({ id, data, selected }) => {
    const { getNode, setNodes } = useReactFlow();

    const handleConnect = (params) => {
        const node = getNode(id);
        const connectedHandles = node.data.connectedHandles || [];

        if (connectedHandles.includes(params.sourceHandle)) {
            return false;
        }

        // Actualiza los handles conectados
        const updatedHandles = [...connectedHandles, params.sourceHandle];
        setNodes((nds) =>
            nds.map((node) =>
                node.id === id
                    ? {
                        ...node,
                        data: {
                            ...node.data,
                            connectedHandles: updatedHandles,
                        },
                    }
                    : node
            )
        );

        return true;
    };

    return (
        <Card sx={{
            minWidth: 150,
            border: selected ? '2px solid black' : '1px solid black',
            borderRadius: 2,
            background: selected ? 'lightgray': 'white'
        }}>
            <Handle
                type="target"
                position={Position.Left}
                onConnect={(params) => console.log('handle onConnect', params)}
                isConnectable={true}
                style={{
                    width: '12px',
                    height: '12px',
                    background: 'white',
                    border: '1px solid black',
                    borderRadius: '50%',
                    left: '-6px'
                }}
            />
            <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <FormatListBulleted fontSize="small" />
                <div>
                    <div style={{ fontWeight: 500 }}>{data.label}</div>
                    <div style={{ fontSize: '0.875rem', color: 'text.secondary' }}>Mensaje con opciones</div>
                </div>
            </CardContent>
            {[...data.options || []].reverse().map((option, index) => {
                const handleId = `option-${data.options.length - index - 1}`;
                const isConnected = data.connectedHandles && data.connectedHandles.includes(handleId);
                return (
                    <Handle
                        key={handleId}
                        type="source"
                        position={Position.Right}
                        id={handleId}
                        isConnectable={!isConnected}
                        onConnect={handleConnect} // ← AGREGAR esto
                        style={{
                            width: '12px',
                            height: '12px',
                            background: 'white',
                            border: '1px solid black',
                            borderRadius: '50%',
                            right: '-6px'
                        }}
                    />
                );
            })}
        </Card>
    );
};

export const CampaignStartNode = ({ id, data, selected }) => {
    const { getNode, setNodes } = useReactFlow();

    const handleConnect = (params) => {
        const node = getNode(id); // Obtiene el nodo actual
        const connectedHandles = node.data.connectedHandles || [];

        if (connectedHandles.includes(params.sourceHandle)) {
            return false;
        }

        // Actualiza los handles conectados en los datos del nodo
        const updatedHandles = [...connectedHandles, params.sourceHandle];
        setNodes((nds) =>
            nds.map((node) =>
                node.id === id
                    ? {
                        ...node,
                        data: {
                            ...node.data,
                            connectedHandles: updatedHandles,
                        },
                    }
                    : node
            )
        );

        return true;
    };

    return (<Card sx={{
        minWidth: 42,
        border: selected ? '1px solid blue' : '1px solid orange',
        borderRadius: 8,
        height: 42
    }}>
        <CardContent sx={{ display: 'flex', alignItems: 'center', padding: 1 }}>
            <PlayArrow sx={{ color: 'orange' }} />
        </CardContent>
        {(data.options || []).map((option, index) => {
                const handleId = `option-${data.options.length - index - 1}`;
                const isConnected = data.connectedHandles && data.connectedHandles.includes(handleId);
                return (
                    <Handle
                        key={handleId}
                        type="source"
                        position={Position.Right}
                        id={handleId}
                        isConnectable={!isConnected}
                        onConnect={handleConnect} // ← AGREGAR esto
                        style={{
                            width: '12px',
                            height: '12px',
                            background: 'white',
                            border: '1px solid black',
                            borderRadius: '50%',
                            right: '-6px'
                        }}
                    />
                );
            })}
    </Card>)
};


export const StartNode = ({ selected }) => (
    <Card sx={{
        minWidth: 42,
        border: selected ? '2px solid green' : '1px solid green',
        borderRadius: 8,
        height: 42
    }}>
        <Handle
            type="source"
            position={Position.Right}
            id="a"
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                right: '-6px'
            }}
        />
        <CardContent sx={{ display: 'flex', alignItems: 'center', padding: 1 }}>
            <PlayArrow sx={{ color: 'green' }} />
        </CardContent>
    </Card>
);
export const MiddleNode = ({ selected }) => (
    <Card sx={{
        width: 42,
        border: selected ? '2px solid orange' : '1px solid orange',
        borderRadius: 8,
        height: 42
    }}>
        <Handle
            type="source"
            position={Position.Right}
            id="a"
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                right: '-6px'
            }}
        />
        <CardContent sx={{ display: 'flex', alignItems: 'center', padding: 1 }}>
            <ArrowForward sx={{ color: 'orange' }} />
        </CardContent>
    </Card>
);

export const EndNode = ({ selected }) => (
    <Card sx={{
        width: 42,
        border: selected ? '2px solid red' : '1px solid red',
        borderRadius: 8,
        height: 42
    }}>
        <Handle
            type="target"
            position={Position.Left}
            id="a"
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                left: '-6px'
            }}
        />
        <CardContent sx={{ display: 'flex', alignItems: 'center', padding: 1 }}>
            <Stop sx={{ color: 'red' }} />
        </CardContent>
    </Card>
);

export const WSPNode = ({ data, selected }) => (
    <Card sx={{
        minWidth: 150,
        border: selected ? '1px solid blue' : '1px solid black',
        borderRadius: 2,
        background: 'mediumseagreen'
    }}>
        <Handle
            type="target"
            position={Position.Left}
            onConnect={(params) => console.log('handle onConnect', params)}
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                left: '-6px'
            }}
        />
        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <WhatsApp fontSize="small" />
            <div>
                <div style={{ fontWeight: 500 }}>{data.label}</div>
                <div style={{ fontSize: '0.875rem', color: 'text.secondary' }}>componente de objeto de Whatsapp</div>
            </div>
        </CardContent>
        <Handle
            type="source"
            position={Position.Right}
            id="a"
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                right: '-6px'
            }}
        />
    </Card>
)

export const AINode = ({ data, selected }) => (
    <Card sx={{
        minWidth: 150,
        border: selected ? '2px solid black' : '1px solid black',
        borderRadius: 2,
        background: selected ? '#6c81acff': '#ACC8FD' 
    }}>
        <Handle
            type="target"
            position={Position.Left}
            onConnect={(params) => console.log('handle onConnect', params)}
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                left: '-6px'
            }}
        />
        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <AutoAwesome fontSize="small" />
            <div>
                <div style={{ fontWeight: 500 }}>{data.label}</div>
                <div style={{ fontSize: '0.875rem', color: 'text.secondary' }}>Integración I.A. con ChatGPT</div>
            </div>
        </CardContent>
        <Handle
            type="source"
            position={Position.Right}
            id="a"
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                right: '-6px'
            }}
        />
    </Card>
)

export const APICallNode = ({ data, selected }) => {
    const truncate = (text, maxLength = 40) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    const method = data.method || 'GET';
    const url = data.url || data.description || 'API';

    return (
        <Card sx={{
            minWidth: 170,
            border: selected ? '2px solid #1e3a8a' : '1px solid #4361ee',
            borderRadius: 2,
            background: selected ? '#e3f2fd' : '#f4f7fb'
        }}>
            <Handle
                type="target"
                position={Position.Left}
                isConnectable={true}
                style={{
                    width: '12px',
                    height: '12px',
                    background: 'white',
                    border: '1px solid black',
                    borderRadius: '50%',
                    left: '-6px'
                }}
            />
            <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Storage fontSize="small" />
                <div>
                    <div style={{ fontWeight: 500 }}>{data.label || 'Memoria / Contexto'}</div>
                    <div style={{ fontSize: '0.875rem', color: 'text.secondary' }}>
                        {method} {truncate(url, 32)}
                    </div>
                    {data.outputKey && (
                        <div style={{ fontSize: '0.75rem', color: '#1e3a8a' }}>
                            Guarda en: {data.outputKey}
                        </div>
                    )}
                </div>
            </CardContent>
            <Handle
                type="source"
                position={Position.Right}
                id="a"
                isConnectable={true}
                style={{
                    width: '12px',
                    height: '12px',
                    background: 'white',
                    border: '1px solid black',
                    borderRadius: '50%',
                    right: '-6px'
                }}
            />
        </Card>
    );
};
export const MediaMessageNode = ({ data, selected }) => {
  const truncate = (text, maxLength = 36) => {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  const mediaType = data.mediaType || 'image';

  const getIcon = () => {
    switch (mediaType) {
      case 'video':
        return <Movie fontSize="small" />;
      case 'document':
        return <Description fontSize="small" />;
      case 'image':
      default:
        return <Image fontSize="small" />;
    }
  };

  const mediaLabelMap = {
    image: 'Imagen',
    video: 'Video',
    document: 'Documento',
  };

  return (
    <Card
      sx={{
        minWidth: 150,
        border: selected ? '2px solid black' : '1px solid black',
        borderRadius: 2,
        background: selected ? 'lavender' : 'white',
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={true}
        style={{
          width: '12px',
          height: '12px',
          background: 'white',
          border: '1px solid black',
          borderRadius: '50%',
          left: '-6px',
        }}
      />
      <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {getIcon()}
        <div>
          <div style={{ fontWeight: 500 }}>
            {truncate(data.label || 'Mensaje multimedia', 40)}
          </div>
          <div style={{ fontSize: '0.75rem', color: 'gray' }}>
            {mediaLabelMap[mediaType] || 'Media'}
            {data.caption ? ` · ${truncate(data.caption, 30)}` : ''}
          </div>
        </div>
      </CardContent>
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        isConnectable={true}
        style={{
          width: '12px',
          height: '12px',
          background: 'white',
          border: '1px solid black',
          borderRadius: '50%',
          right: '-6px',
        }}
      />
    </Card>
  );
};
export const FlowNode = ({ selected }) => (
    <Card sx={{
        width: 42,
        border: selected ? '1px solid blue' : '1px solid orange',
        borderRadius: 8,
        height: 42
    }}>
        <Handle
            type="target"
            position={Position.Left}
            id="a"
            isConnectable={true}
            style={{
                width: '12px',
                height: '12px',
                background: 'white',
                border: '1px solid black',
                borderRadius: '50%',
                left: '-6px'
            }}
        />
        <CardContent sx={{ display: 'flex', alignItems: 'center', padding: 1 }}>
            <Polyline sx={{ color: 'orange' }} />
        </CardContent>
    </Card>
);

// Nuevo nodo: wsp_flow (Meta WhatsApp Flow)
export const WspFlowNode = ({ data, selected }) => {
    const truncate = (text, maxLength = 42) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    const flowName = data?.whatsappFlowName || '';
    const flowId = data?.whatsappFlowId || '';

    return (
        <Card sx={{
            minWidth: 190,
            border: selected ? '2px solid black' : '1px solid black',
            borderRadius: 2,
            background: selected ? 'lavender' : 'white'
        }}>
            <Handle
                type="target"
                position={Position.Left}
                isConnectable={true}
                style={{
                    width: '12px',
                    height: '12px',
                    background: 'white',
                    border: '1px solid black',
                    borderRadius: '50%',
                    left: '-6px'
                }}
            />
            <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <WhatsApp fontSize="small" sx={{ color: 'green' }} />
                <div>
                    <div style={{ fontWeight: 600 }}>WhatsApp Flow</div>
                    <div style={{ fontSize: '0.875rem', color: 'text.secondary' }}>
                        {truncate(flowName || 'Sin configurar', 40)}
                    </div>
                    {flowId ? (
                        <div style={{ fontSize: '0.75rem', color: 'gray' }}>
                            {truncate(flowId, 44)}
                        </div>
                    ) : null}
                </div>
            </CardContent>
            <Handle
                type="source"
                position={Position.Right}
                id="a"
                isConnectable={true}
                style={{
                    width: '12px',
                    height: '12px',
                    background: 'white',
                    border: '1px solid black',
                    borderRadius: '50%',
                    right: '-6px'
                }}
            />
        </Card>
    );
};

export const DocumentPdfNode = ({ data, selected }) => (
  <Card sx={{
    minWidth: 150,
    border: selected ? '2px solid black' : '1px solid black',
    borderRadius: 2,
    background: selected ? 'mistyrose' : 'white',
  }}>
    <Handle
      type="target"
      position={Position.Left}
      isConnectable={true}
      style={{
        width: '12px',
        height: '12px',
        background: 'white',
        border: '1px solid black',
        borderRadius: '50%',
        left: '-6px',
      }}
    />
    <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <PictureAsPdf fontSize="small" />
      <div>
        <div style={{ fontWeight: 600 }}>{data.label || 'Documento PDF'}</div>
        <div style={{ fontSize: '0.75rem', color: 'gray' }}>
          {data.OutputKey ? `output: ${data.OutputKey}` : 'OutputKey requerido'}
        </div>
      </div>
    </CardContent>
    <Handle
      type="source"
      position={Position.Right}
      id="a"
      isConnectable={true}
      style={{
        width: '12px',
        height: '12px',
        background: 'white',
        border: '1px solid black',
        borderRadius: '50%',
        right: '-6px',
      }}
    />
  </Card>
);
export const MediaUploadNode = ({ data, selected }) => {
  const accountId = data?.AccountId;
  const inputVarKey = data?.InputVarKey;
  const outputKey = data?.OutputKey;

  const missingAccountId = !accountId;
  const missingInputVarKey = !String(inputVarKey || '').trim();
  const missingOutputKey = !String(outputKey || '').trim();
  const hasErrors = missingAccountId || missingInputVarKey || missingOutputKey;

  const subtitleParts = [];
  if (data?.MediaType) subtitleParts.push(String(data.MediaType));
  if (data?.Filename) subtitleParts.push(String(data.Filename));
  const subtitle = subtitleParts.length ? subtitleParts.join(' · ') : 'Configura Base64 → media_id';

  return (
    <Card
      sx={{
        minWidth: 190,
        border: selected ? '2px solid black' : hasErrors ? '2px solid #d32f2f' : '1px solid black',
        borderRadius: 2,
        background: selected ? '#f3f4f6' : '#ffffff',
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={true}
        style={{
          width: '12px',
          height: '12px',
          background: 'white',
          border: '1px solid black',
          borderRadius: '50%',
          left: '-6px',
        }}
      />

      <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <CloudUpload fontSize="small" />
        <div>
          <div style={{ fontWeight: 600 }}>Media Upload</div>
          <div style={{ fontSize: '0.875rem', color: 'text.secondary' }}>{subtitle}</div>
          <div style={{ fontSize: '0.75rem', color: hasErrors ? '#d32f2f' : 'gray' }}>
            {missingAccountId ? 'AccountId requerido' : `AccountId: ${accountId}`}
            {' · '}
            {missingInputVarKey ? 'InputVarKey requerido' : `in: {{${inputVarKey}}}`}
            {' · '}
            {missingOutputKey ? 'OutputKey requerido' : `out: ${outputKey}`}
          </div>
        </div>
      </CardContent>

      <Handle
        type="source"
        position={Position.Right}
        id="a"
        isConnectable={true}
        style={{
          width: '12px',
          height: '12px',
          background: 'white',
          border: '1px solid black',
          borderRadius: '50%',
          right: '-6px',
        }}
      />
    </Card>
  );
};

export const DocumentInboxNode = ({ data, selected }) => (
  <Card sx={{
    minWidth: 180,
    border: selected ? '2px solid black' : '1px solid black',
    borderRadius: 2,
    background: selected ? '#e8f5e9' : '#f1f8f4',
  }}>
    <Handle
      type="target"
      position={Position.Left}
      isConnectable={true}
      style={{
        width: '12px',
        height: '12px',
        background: 'white',
        border: '1px solid black',
        borderRadius: '50%',
        left: '-6px',
      }}
    />
    <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Inbox fontSize="small" sx={{ color: 'green' }} />
      <div>
        <div style={{ fontWeight: 600 }}>{data?.label || 'Bandeja de documentos'}</div>
        <div style={{ fontSize: '0.75rem', color: 'gray' }}>
          Espera attachments y avanza al recibir todos
        </div>
      </div>
    </CardContent>
    <Handle
      type="source"
      position={Position.Right}
      id="a"
      isConnectable={true}
      style={{
        width: '12px',
        height: '12px',
        background: 'white',
        border: '1px solid black',
        borderRadius: '50%',
        right: '-6px',
      }}
    />
  </Card>
);

export const EnqueueHumanNode = ({ data, selected }) => (
  <Card sx={{
    minWidth: 170,
    border: selected ? '2px solid #b45309' : '1px solid #f97316',
    borderRadius: 2,
    background: selected ? '#fed7aa' : '#fff7ed',
  }}>
    <Handle
      type="target"
      position={Position.Left}
      isConnectable={true}
      style={{
        width: '12px',
        height: '12px',
        background: 'white',
        border: '1px solid black',
        borderRadius: '50%',
        left: '-6px',
      }}
    />
    <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <SupportAgent fontSize="small" sx={{ color: '#f97316' }} />
      <div>
        <div style={{ fontWeight: 600 }}>{data.label || 'Encolar Humano'}</div>
        <div style={{ fontSize: '0.75rem', color: '#92400e' }}>
          {data.notes ? `Nota: ${data.notes.slice(0, 28)}${data.notes.length > 28 ? '…' : ''}` : 'Cola de espera humana'}
        </div>
      </div>
    </CardContent>
    <Handle
      type="source"
      position={Position.Right}
      id="a"
      isConnectable={true}
      style={{
        width: '12px',
        height: '12px',
        background: 'white',
        border: '1px solid black',
        borderRadius: '50%',
        right: '-6px',
      }}
    />
  </Card>
);

export const nodeTypes = {
    event: EventNode,
    condition: ConditionNode,
    message: MessageNode,
    button: ButtonNode,
    list: ListNode,
    start: StartNode,
    middle: MiddleNode,
    end: EndNode,
    wsp: WSPNode,
    campaign: CampaignStartNode,
    agent: AINode,
    apicall: APICallNode,
    flow: FlowNode,
    mediamessage: MediaMessageNode,
    wsp_flow: WspFlowNode,
    document_pdf: DocumentPdfNode,
    media_upload: MediaUploadNode,
    document_inbox: DocumentInboxNode,
    enqueue_human: EnqueueHumanNode,
};
